
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace",
      function () {
        return require("private-next-pages/marketplace.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace"])
      });
    }
  